import * as React from "react"
import { Trans } from 'gatsby-plugin-react-i18next';

import { VideoTxt } from "../../components/video-txt/video-txt"
import {Text} from "../text/text"

import cloudImg from "../../images/blu-sky.jpg";

import './cloud.scss';

// Defining the <Greeting> component
export const Cloud = (props) => {
  const video = "https://media.loropiana.com/video/hiroshifujiwara/cloud/video.mp4"
  let text = <Trans>LoroPiana</Trans>
  return (
    <div className="cloud">
      <VideoTxt poster={cloudImg} video={video} text={text}></VideoTxt>

      <Text page={'reasonwhy'}></Text>
    </div>
        
    )
  }